/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkOpResultDTO } from './BulkOpResultDTO';
import {
    BulkOpResultDTOFromJSON,
    BulkOpResultDTOFromJSONTyped,
    BulkOpResultDTOToJSON,
} from './BulkOpResultDTO';

/**
 * 
 * @export
 * @interface ProjectBulkOpResultDTO
 */
export interface ProjectBulkOpResultDTO {
    /**
     * 
     * @type {{ [key: string]: BulkOpResultDTO; }}
     * @memberof ProjectBulkOpResultDTO
     */
    resultsByProject: { [key: string]: BulkOpResultDTO; };
}

/**
 * Check if a given object implements the ProjectBulkOpResultDTO interface.
 */
export function instanceOfProjectBulkOpResultDTO(value: object): value is ProjectBulkOpResultDTO {
    if (!('resultsByProject' in value) || value['resultsByProject'] === undefined) return false;
    return true;
}

export function ProjectBulkOpResultDTOFromJSON(json: any): ProjectBulkOpResultDTO {
    return ProjectBulkOpResultDTOFromJSONTyped(json, false);
}

export function ProjectBulkOpResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectBulkOpResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'resultsByProject': (mapValues(json['resultsByProject'], BulkOpResultDTOFromJSON)),
    };
}

export function ProjectBulkOpResultDTOToJSON(value?: ProjectBulkOpResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'resultsByProject': (mapValues(value['resultsByProject'], BulkOpResultDTOToJSON)),
    };
}

